export default ({ locale }) => {
    switch (locale) {
        default:
            return {
                email: {
                    placeholder: 'Enter your email',
                    label: 'Please enter your email address to reset your password',
                },
                reset: 'Reset',
                alreadyKnowPassword: 'I know my password',
            };
    }
};
